import { Allocation, PolicyItem } from '@ndvr/portfolio-api';

/** Match trading's fixed strategy order, applying portfolio overrides only to strategies in the allocation. */
export const resolveAssetLocationPolicy = (
    allocations: Allocation[],
    defaults: PolicyItem[] = [],
    overrides: PolicyItem[] = [],
): PolicyItem[] => {
    const activeTypes = new Set(
        allocations.flatMap(
            (allocation) => allocation?.strategyAllocations?.map((item) => item.growthAllocationType) ?? [],
        ),
    );
    const overridesByType = new Map(overrides.map((item) => [item.growthAllocationType, item]));
    const defaultsByType = new Map(defaults.map((item) => [item.growthAllocationType, item]));
    const priority = new Map(defaults.map((item, index) => [item.growthAllocationType, index]));
    return [...activeTypes]
        .sort((a, b) => (priority.get(a) ?? defaults.length) - (priority.get(b) ?? defaults.length))
        .map((type) => overridesByType.get(type) ?? defaultsByType.get(type))
        .filter((item): item is PolicyItem => item !== undefined);
};
